/* cart-upsell.js — Versión final: refresca y abre el drawer al vuelo */

(() => {
  // 0️⃣ Obtiene la configuración inyectada por Liquid
  if (!window.upsellData) return;
  const { vid, title, price_cents, img_url } = window.upsellData;

  // 1️⃣ Polyfill para Shopify.formatMoney (si no existe)
  if (typeof window.Shopify === 'undefined') window.Shopify = {};
  if (typeof Shopify.formatMoney !== 'function') {
    Shopify.formatMoney = (cents, fmt = '${{amount}}') =>
      fmt.replace('{{amount}}', (cents / 100).toFixed(2));
  }
  const moneyFmt     = window.kiwopMoneyFormat || Shopify.money_format || '${{amount}}';
  const formatPrice = cents => Shopify.formatMoney(cents, moneyFmt);

  // 2️⃣ Función para pintar el bloque upsell
  function renderUpsell() {
    const box = document.querySelector('#CartUpsell');
    if (!box) return;

    const src = img_url.includes('?')
      ? `${img_url}&width=120`
      : `${img_url}?width=120`;

    box.innerHTML = `
      <article class="kiw-card">
        <figure class="kiw-img">
          <img src="${src}" alt="${title}">
        </figure>
        <div class="kiw-body">
          <h3 class="kiw-title">${title}</h3>
          <p class="kiw-price">${formatPrice(price_cents)}</p>
          <button class="kiw-btn" data-id="${vid}">Add Now</button>
        </div>
      </article>`;
  }

  // 3️⃣ Función para abrir el drawer tras actualizarlo
  function openDrawer() {
    if (window.AVADA_CART?.open) {
      window.AVADA_CART.open();
    } else if (window.AvadaCartDrawer?.open) {
      window.AvadaCartDrawer.open();
    } else {
      window.dispatchEvent(new Event('avada:drawer-cart-open'));
    }
  }

  // 4️⃣ Función que reinyecta todo el mini-cart y re-abre el drawer
  async function refreshDrawer() {
    const json = await fetch('/?sections=cart-drawer').then(r => r.json());
    const html = json['cart-drawer'];
    const drawer = document.querySelector('#cart-drawer');
    if (drawer && html) {
      drawer.innerHTML = html;
      renderUpsell();   // reinyecta upsell
      openDrawer();     // abre el drawer
    } else {
      // fallback: recarga la página completa
      window.location.reload();
    }
  }

  // 5️⃣ Listener de clic en el botón Add Now
  document.addEventListener('click', async (e) => {
    const btn = e.target;
    if (!btn.matches('#CartUpsell .kiw-btn')) return;

    e.preventDefault();
    const variantId = Number(btn.dataset.id);
    const original  = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled    = true;

    try {
      const res = await fetch('/cart/add.js', {
        method : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body   : JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!res.ok) throw new Error('Add to cart failed');

      await refreshDrawer();
    } catch (err) {
      console.error('Upsell Error:', err);
      window.location.reload();
    } finally {
      btn.textContent = original;
      btn.disabled    = false;
    }
  });

  // 6️⃣ Hooks para pintar el bloque cuando se abra o actualice el cart drawer
  document.addEventListener('avada:drawer-cart-opened', renderUpsell);
  document.addEventListener('cart:updated',               renderUpsell);

  // 7️⃣ Primera carga (por si el drawer ya está abierto)
  renderUpsell();
})();